<div class="container">
  <div class="section-title">
    <h2>{{itemDetail?.title}}</h2>
    <a routerLink="/bando/{{itemDetail.id}}">{{itemDetail?.address}} (Gps: {{itemDetail?.gpsLong}},
      {{itemDetail?.gpsLat}})</a>
  </div>
</div>
<div class="container">
  <div class="p-fluid p-formgrid grid flex justify-content-end flex-wrap">
    <p-dropdown [options]="listTramDo" [(ngModel)]="selectedItem" (onChange)="onChangeTramDo()">
    </p-dropdown> &nbsp;
    <button pButton type="button" (click)="actionHidden.toggle($event)" icon="pi pi-calendar"
      class="p-button-secondary">
    </button>
    <p-overlayPanel #actionHidden [hideTransitionOptions]="'0ms'" [showTransitionOptions]="'0ms'" appendTo="body"
      styleClass="sv-overlay-menu style-1">
      <div class="p-fluid p-formgrid grid" style="flex: 1;">
        <div class="field col-5 md:col-5">
          <label>Từ ngày</label>
          <p-calendar [(ngModel)]="tuNgay" [showTime]="true" hourFormat="24" />
        </div>
        <div class="field col-5 md:col-5">
          <label>Đến ngày</label>
          <p-calendar [(ngModel)]="denNgay" [showTime]="true" hourFormat="24" />
        </div>
        <div class="field col-2 md:col-2">
          <label>&nbsp;</label>
          <button pButton type="button" id="act-refresh" class="mr-2" class="p-button  p-button-secondary"
            label="{{'Chọn' | translate}}" icon="ci ci-search" (click)="onSearch()">
          </button>
        </div>
      </div>
    </p-overlayPanel>
  </div>
</div>
<div class="container" *ngIf="dataGio.length > 0">
  <div class="row">
    <div class="col-3 md:col-3">
      <div class="row">
        <highcharts-chart [Highcharts]="Highcharts" [options]="polarChartOptions"
          style="width: 100%; height: 400px; display: block;"></highcharts-chart>
      </div>
      <div class="row mt-1" style="background-color: white; height: 55px;">
        <h6 style="color: #000; text-align: center; margin-top: 10px; margin-bottom: 10px;">
          {{ (getTextHuongGio(itemHuongGio.giaTri)).toUpperCase()}}
          ({{itemHuongGio.giaTri}} độ)
        </h6>
      </div>
    </div>
    <div class="col-9 md:col-9">
      <highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions"
        style="width: 100%; height: 460px; display: block;"></highcharts-chart>
    </div>
  </div>
  <div class="row">
    <ng-container *ngFor="let item of listChartOptions">
      <div class="col-12 md:col-12">
        <highcharts-chart [Highcharts]="Highcharts1" [options]="item"
          style="width: 100%; height: 400px; display: block;">
        </highcharts-chart>
      </div>
    </ng-container>
  </div>
</div>

<!--
<div class="container">
  <div class="row">
    <h2>Báo cáo dữ liệu đo theo tháng</h2>
  </div>
</div>
<ng-container>
  <div class="container">
    <div class="p-fluid p-formgrid grid" style="flex: 1;">
      <div class="field col-6 md:col-2">
        <label>Tháng</label>
        <p-calendar [(ngModel)]="monthReport" view="month" dateFormat="mm/yy" />
      </div>
      <div class="field col-6 md:col-2">
        <label>Yếu tố đo</label>
        <p-dropdown [options]="optionDmYeuTodo" [(ngModel)]="idDmYeuToDo"></p-dropdown>
      </div>
      <div class="field col-6 md:col-2">
        <label>&nbsp;</label>
        <button pButton type="button" id="act-refresh" class="mr-2" class="p-button-secondary p-button-text"
          label="{{'Báo cáo' | translate}}" icon="ci ci-restart" (click)="getDataMonth()">
        </button>
      </div>
      <div class="field col-6 md:col-2">
        <label>&nbsp;</label>
        <button pButton type="button" id="act-download" class="mr-2" class="p-button-secondary p-button-text"
          label="{{'BUTTON.EXPORT_EXCEL' | translate}}" icon="ci ci-upload" (click)="exportExcelMonth()">
        </button>
      </div>
    </div>
  </div>
  <div class="container pb-5" *ngIf="dataSourceMonth.length > 0">
    <ng-container *ngIf="dataSource.length > 0">
      <div class="sv-table-wrapper">
        <p-table [columns]="cols1" [value]="dataSourceMonth" class="sv-table -status-style-border-left"
          [loading]="isLoading" [lazy]="true">
          <ng-template pTemplate="colgroup">
            <colgroup>
              <ng-container *ngFor="let col of cols1">
                <col [hidden]="!col.visible" [style.width]="col.width">
              </ng-container>
            </colgroup>
          </ng-template>
          <ng-template let-columns pTemplate="header">
            <tr>
              <ng-container *ngFor="let col of columns">
                <th *ngIf="col.sort" [hidden]="!col.visible" [pSortableColumn]="col.field">
                  <div class="h-flex-el -h-space-between">
                    <div class="h-overflow-break-word">{{col.header}}</div>
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                  </div>
                </th>
                <th *ngIf="!col.sort" [hidden]="!col.visible">
                  <div class="h-overflow-break-word">{{col.header}}</div>
                </th>
              </ng-container>
            </tr>
          </ng-template>

          <ng-template let-columns="columns" let-rowData let-rowIndex="rowIndex" pTemplate="body">
            <tr [class.sv-tr-status-danger]="rowData.status === 3" [class.sv-tr-status-success]="rowData.status === 1"
              [class.sv-tr-status-warning]="rowData.status === 2" [class.sv-tr-status]="rowData.status">

              <td *ngFor="let col of columns" [hidden]="!col.visible" [ngSwitch]="col.field">
                <span *ngSwitchCase="'thoiGianDo'">
                  {{rowData.thoiGianDo | date:'dd/MM/yyyy'}}
                </span>
                <span *ngSwitchDefault>{{rowData[col.field]}}</span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </ng-container>
  </div>
</ng-container>

<div class="container">
  <div class="row">
    <h2>Tra cứu dữ liệu đo</h2>
  </div>
  <div class="p-fluid p-formgrid grid" style="flex: 1;">
    <div class="field col-6 md:col-2">
      <label>Từ ngày</label>
      <p-calendar [(ngModel)]="tuNgay" [showTime]="true" hourFormat="24" />
    </div>
    <div class="field col-6 md:col-2">
      <label>Đến ngày</label>
      <p-calendar [(ngModel)]="denNgay" [showTime]="true" hourFormat="24" />
    </div>
    <div class="field col-6 md:col-2">
      <label>&nbsp;</label>
      <button pButton type="button" id="act-download" class="mr-2" class="p-button-secondary p-button-text"
        label="{{'BUTTON.EXPORT_EXCEL' | translate}}" icon="ci ci-upload" (click)="exportToExcel()">
      </button>
    </div>
    <div class="field col-6 md:col-2">
      <label>&nbsp;</label>
      <button pButton type="button" id="act-refresh" class="mr-2" class="p-button-secondary p-button-text"
        label="{{'BUTTON.RELOAD' | translate}}" icon="ci ci-restart" (click)="onSearch()">
      </button>
    </div>
  </div>
</div>
<div class="container">
  <div class="sv-table-wrapper">
    <table class="table table-bordered" #tblData>
      <thead>
        <tr>
          <th colspan="2">Thời gian</th>
          <th [attr.colspan]="listTramDoYeuToDo.length">Số liệu đo</th>
        </tr>
        <tr>
          <td style="width: 100px;">Ngày</td>
          <td style="width: 100px;">Giờ</td>
          <ng-container *ngFor="let item of listTramDoYeuToDo">
            <td>{{item.titleDmYeuToDo}} ({{item.codeDmYeuToDo}})</td>
          </ng-container>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of dataSource">
          <td>{{item.thoiGianDo | date: 'dd/MM/yyyy'}}</td>
          <td>{{item.thoiGianDo | date: 'HH:mm:ss'}}</td>
          <ng-container *ngFor="let itemYeuToDo of listTramDoYeuToDo">
            <td>{{item[itemYeuToDo.idDmYeuToDo]}}</td>
          </ng-container>
        </tr>
      </tbody>
    </table>
  </div>
</div> -->